import React from "react";
import { Link } from "react-router-dom";
import { useAppContext } from "../../../../../context/AppContext";

function JourneyAction({ action, variant = "primary" }) {
    if (!action) {
        return null;
    }

    const className = variant === "primary" ? "btn btn-primary" : "btn btn-outline-primary";
    const isExternal = /^https?:\/\//.test(action.to);

    if (isExternal) {
        return (
            <a href={action.to} className={className} target="_blank" rel="noreferrer">
                {action.label}
            </a>
        );
    }

    return (
        <Link to={action.to} className={className}>
            {action.label}
        </Link>
    );
}

export default function JourneyPage({
    title,
    subtitle,
    eyebrow,
    primaryAction,
    secondaryAction,
    children,
}) {
    const { appData } = useAppContext();

    return (
        <div className="journey-shell min-vh-100">
            <div className="container py-4 py-lg-5">
                <div className="journey-nav d-flex justify-content-between align-items-center mb-4">
                    <Link to="/" className="journey-brand d-flex align-items-center gap-2">
                        {appData?.logo && (
                            <img className="rounded" src={appData.logo} alt="Logo" width="48" height="48" />
                        )}
                        <span className="fw-bold">{appData?.name}</span>
                    </Link>
                    <div className="d-flex gap-2">
                        <Link to="/login" className="btn btn-outline-primary btn-sm">Login</Link>
                        <Link to="/register" className="btn btn-primary btn-sm">Register</Link>
                    </div>
                </div>

                <div className="journey-hero row align-items-start g-4">
                    <div className="col-xl-4 col-lg-5">
                        <div className="journey-eyebrow mb-3 text-uppercase fw-bold fs-12">{eyebrow}</div>
                        <h1 className="journey-title display-6 fw-bold mb-3">{title}</h1>
                        <p className="journey-subtitle fs-18 mb-4">{subtitle}</p>
                        <div className="d-flex flex-wrap gap-2">
                            <JourneyAction action={primaryAction} />
                            <JourneyAction action={secondaryAction} variant="secondary" />
                        </div>
                    </div>
                    <div className="col-xl-8 col-lg-7">
                        {children}
                    </div>
                </div>

                <footer className="journey-footer text-center mt-5 small">
                    &copy; {new Date().getFullYear()} {appData?.name}.{" "}
                    <Link to="/legal" className="text-muted">Legal</Link>
                    {" "}&bull;{" "}
                    <Link to="/help" className="text-muted">Help</Link>
                </footer>
            </div>
        </div>
    );
}
